/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PamPlayerVerificationStatus } from './PamPlayerVerificationStatus';
import {
    PamPlayerVerificationStatusFromJSON,
    PamPlayerVerificationStatusFromJSONTyped,
    PamPlayerVerificationStatusToJSON,
} from './PamPlayerVerificationStatus';

/**
 * A single status transition from the append-only audit table.
 * @export
 * @interface PamVerificationHistoryEntry
 */
export interface PamVerificationHistoryEntry {
    /**
     * 
     * @type {any}
     * @memberof PamVerificationHistoryEntry
     */
    vendorRawResponse?: any | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PamVerificationHistoryEntry
     */
    potentialDuplicates?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationHistoryEntry
     */
    reason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationHistoryEntry
     */
    reasonCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationHistoryEntry
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationHistoryEntry
     */
    changedBy: string;
    /**
     * 
     * @type {PamPlayerVerificationStatus}
     * @memberof PamVerificationHistoryEntry
     */
    toStatus: PamPlayerVerificationStatus;
    /**
     * 
     * @type {PamPlayerVerificationStatus}
     * @memberof PamVerificationHistoryEntry
     */
    fromStatus: PamPlayerVerificationStatus | null;
}



/**
 * Check if a given object implements the PamVerificationHistoryEntry interface.
 */
export function instanceOfPamVerificationHistoryEntry(value: object): value is PamVerificationHistoryEntry {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('changedBy' in value) || value['changedBy'] === undefined) return false;
    if (!('toStatus' in value) || value['toStatus'] === undefined) return false;
    if (!('fromStatus' in value) || value['fromStatus'] === undefined) return false;
    return true;
}

export function PamVerificationHistoryEntryFromJSON(json: any): PamVerificationHistoryEntry {
    return PamVerificationHistoryEntryFromJSONTyped(json, false);
}

export function PamVerificationHistoryEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamVerificationHistoryEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'vendorRawResponse': json['vendorRawResponse'] == null ? undefined : json['vendorRawResponse'],
        'potentialDuplicates': json['potentialDuplicates'] == null ? undefined : json['potentialDuplicates'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'reasonCode': json['reasonCode'] == null ? undefined : json['reasonCode'],
        'createdAt': json['createdAt'],
        'changedBy': json['changedBy'],
        'toStatus': PamPlayerVerificationStatusFromJSON(json['toStatus']),
        'fromStatus': PamPlayerVerificationStatusFromJSON(json['fromStatus']),
    };
}

export function PamVerificationHistoryEntryToJSON(value?: PamVerificationHistoryEntry | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'vendorRawResponse': value['vendorRawResponse'],
        'potentialDuplicates': value['potentialDuplicates'],
        'reason': value['reason'],
        'reasonCode': value['reasonCode'],
        'createdAt': value['createdAt'],
        'changedBy': value['changedBy'],
        'toStatus': PamPlayerVerificationStatusToJSON(value['toStatus']),
        'fromStatus': PamPlayerVerificationStatusToJSON(value['fromStatus']),
    };
}

